import React, { Component } from "react"

export default class Cinemagraph extends Component {
	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this);
		this.onPlayIntersection = this.onPlayIntersection.bind(this);
		this.state = {
			inView: false,
			loaded: false,
			play: false,
		}
	}

	componentDidMount() {
		let options = {
			root: null,
			rootMargin: "0px 0px 80% 0px",
			threshold: 0
		};
		let observer = new IntersectionObserver(this.onIntersection, options);
		observer.observe(this.$box);
		
		let playOptions = {
			root: null,
			rootMargin: "0px",
			threshold: 0
		};
		let playObserver = new IntersectionObserver(this.onPlayIntersection, playOptions);
		playObserver.observe(this.$box);
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	}
	
	onPlayIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.play === false) {
				this.setState({ play: true });
			} else if (entry.intersectionRatio === 0 && this.state.play === true) {
				this.setState({ play: false });
			}					
		});
	}
	

	render() {
    	const poster = this.props.poster;
    	const src = this.props.src;
		const width = this.props.width;
    	const height = this.props.height;

		if (src) {
			return (
				<div className="c-media state-media-loaded" style={{ paddingTop: `${(height / width) * 100}%` }} ref={(box) => { this.$box = box; }}>
					<div className="c-media__inner">
						{this.state.inView &&
							<>
								{this.state.play &&
									<video
										src={src}
										poster={poster}
										autoPlay
										loop
										muted
										playsInline
									></video>
								}
								{!this.state.play &&
									<video
										src={src}
										poster={poster}
										loop
										muted
										playsInline
									></video>
								}
							</>
						}
					</div>
				</div>
			)
    	} else {
			return null
    	}
	}
}
